import Model from 'flarum/common/Model';
export default class Status extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  slug() {
    return Model.attribute('slug').call(this);
  }
  color() {
    return Model.attribute('color').call(this);
  }
  textColor() {
    return Model.attribute('textColor').call(this);
  }
  position() {
    return Model.attribute('position').call(this);
  }
  isRestricted() {
    return Model.attribute('isRestricted').call(this);
  }
  canUse() {
    return Model.attribute('canUse').call(this);
  }
  discussionCount() {
    return Model.attribute('discussionCount').call(this);
  }
}
flarum.reg.add('neverhack-forum-nodes', 'common/models/Status', Status);